/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    pro: PropTypes.bool,
    premium: PropTypes.bool,
    inner: PropTypes.bool,
    color: PropTypes.bool,
    column: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    pro: false,
    premium: false,
    inner: false,
    color: false,
    column: false,
};

const Advert = (props) => {
    const classNames = [
        'c-advert',
        props.pro ? 'c-advert--pro' : '',
        props.premium ? 'c-advert--premium' : '',
        props.inner ? 'c-advert--inner' : '',
        props.color ? 'c-advert--color' : '',
        props.column ? 'c-advert--column' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Advert.propTypes = propTypes;

Advert.defaultProps = defaultProps;

export default Advert;
